import React from "react";

/**
 * Circular SVG countdown ring.
 * Props:
 *  - value: current remaining (seconds)
 *  - total: initial total (seconds) for proportional rendering
 *  - size: outer pixel size (default 64)
 *  - stroke: ring thickness (default 5)
 *  - color: ring color CSS var or hex (default gold)
 *  - children: rendered at the center
 */
export const CircularCountdown = ({
  value,
  total,
  size = 64,
  stroke = 5,
  color = "var(--gl-gold)",
  children,
  "data-testid": testId,
}) => {
  const safeTotal = total > 0 ? total : 1;
  const ratio = Math.max(0, Math.min(1, value / safeTotal));
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - ratio);

  return (
    <div
      className="relative shrink-0"
      style={{ width: size, height: size }}
      data-testid={testId}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="-rotate-90"
        aria-hidden="true"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.9s linear" }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        {children}
      </div>
    </div>
  );
};

export default CircularCountdown;
